import MacleJSBridge from 'src/bridges';
import { APINames } from 'src/shared';
import { GeneralInvokeOption } from 'src/types';
import { paramCheck } from '../../utils';

export interface ShowLoadingOption extends Partial<GeneralInvokeOption> {
  title?: string;
  mask?: Boolean;
  invalidParamObj?: '';
}

// 显示loading提示框，需主动调用ma.hideLoading才能关闭提示框
export function showLoading(option?: ShowLoadingOption) {
  const fixedOption = Object.assign(
    {
      title: 'Loading...',
      mask: false
    },
    option
  );
  if (
    paramCheck(APINames.Native.SHOW_LOADING, fixedOption, {
      title: '',
      mask: false
    })
  ) {
    return MacleJSBridge.beforeInvoke(
      APINames.Native.SHOW_LOADING,
      fixedOption
    );
  }
  return fixedOption.invalidParamObj;
}
